// =============================================================================
// DATA / BAR.JS — Mobile bar services (Calgary)
// Field order: Setup → Pricing → Alcohol → Cocktails → Mocktails → Guest Count
//   → AGLC → Licensed & Insured → Email → Phone → Instagram → Website
// =============================================================================

export const barData = [
  { name: "Black Tie & Bourbon Events", tier: "$/$$", fields: [
    { label: "Setup", value: "Two mobile bars available; staffing-only option also offered" },
    { label: "Pricing", value: "Customized packages to accommodate all budgets" },
    { label: "Alcohol", value: "Can supply alcohol OR work with client-supplied alcohol" },
    { label: "Cocktails", value: "Wide variety of signature cocktails available" },
    { label: "Mocktails", value: "Yes — wide variety of mocktails and dirty sodas available" },
    { label: "Guest Count", value: "No minimum or maximum — 500+ bartenders on roster" },
    { label: "AGLC", value: "Can handle the liquor licence or guide couples through the process themselves" },
    { label: "Licensed & Insured", value: "Yes" },
    { label: "Email", value: "blacktieandbourbon@gmail.com" },
    { label: "Instagram", value: "@blacktieandbourbonevents" },
  ]},
  { name: "In the Mix Bartending", tier: "$/$$", fields: [
    { label: "Setup", value: "Full bar setup, equipment, glassware, mix & garnish provided" },
    { label: "Alcohol", value: "Can supply alcohol OR work with client-supplied alcohol" },
    { label: "Cocktails", value: "Custom signature cocktail menus available" },
    { label: "Mocktails", value: "Yes — full mocktail menus available" },
    { label: "Guest Count", value: "No minimum or maximum — all event sizes welcome" },
    { label: "AGLC", value: "Handles licensing when supplying alcohol; client responsible if supplying own" },
    { label: "Email", value: "inthemixcalgary@gmail.com" },
    { label: "Website", value: "inthemixcalgary.com", link: "https://www.inthemixcalgary.com" },
  ]},
  { name: "The Prosecco Cart Inc.", tier: "$/$$", fields: [
    { label: "Setup", value: "Full mobile bar setup including dedicated bartenders" },
    { label: "Pricing", value: "Custom per event; minimum two-hour booking" },
    { label: "Alcohol", value: "Client supplies own — team can help place the order" },
    { label: "Cocktails", value: "Yes — signature cocktail creation available" },
    { label: "Mocktails", value: "Yes — non-alcoholic menus available" },
    { label: "Guest Count", value: "No minimum or maximum" },
    { label: "AGLC", value: "Couple or venue is responsible for the liquor licence" },
    { label: "Licensed & Insured", value: "Yes" },
    { label: "Email", value: "info@proseccocart.ca" },
    { label: "Instagram", value: "@theproseccocart" },
    { label: "Website", value: "proseccocart.ca", link: "https://www.proseccocart.ca" },
  ]},
  { name: "Suds & Sodas Mobile Bar", tier: "$", fields: [
    { label: "Pricing", value: "From $825 portable / $1,265 truck / $1,565 Piaggio Ape bar" },
    { label: "Setup", value: "Full setup except alcohol — portable station, beverage truck, or Piaggio Ape bar" },
    { label: "Alcohol", value: "Client supplies own (Suds & Sodas can purchase on your behalf)" },
    { label: "Mocktails", value: "Yes — known for their mocktail menus" },
    { label: "Guest Count", value: "20–2,000 guests" },
    { label: "AGLC", value: "Client/venue responsible — easy online application at aglc.ca" },
    { label: "Insurance", value: "$5M general liability, WCB coverage, City of Calgary business licence" },
    { label: "Email", value: "melissa@sudsandsodas.com" },
    { label: "Instagram", value: "@sudsandsodas" },
    { label: "Website", value: "sudsandsodas.com", link: "https://www.sudsandsodas.com" },
  ]},
];


export const barPending = ["The Wildflower Wandering Bar  thewildflower.ca", "True Spirits Mobile Bar  truespiritsmobilebar.com", "Olive and Twist Mobile Bar  oliveandtwistmobilebar.com", "Sugar Water  sugarwater.bar"];
